<template>
    <span>{{ price }} TL</span>
</template>

<script>
export default {
    props: ['price']
}

</script>